<template>
  <v-app>
    <Header/>
    <v-main>
      <Home/>
    </v-main>
  </v-app>
</template>

<script>
import Header from './components/Header';
import Home from './components/Home';

export default {
  name: 'App',

  components: {
    Header,
    Home,
  },

  data: () => ({
    //
  }),
};
</script>

<style lang="scss">
main {
  background: #F5F6F8;
}
</style>
